import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IBrandViewV2Response) {
    (function(ILeanBrand) {
        ILeanBrand.build = function(partial) {
            return _object_spread({
                active_promo_collections: [],
                badges: [],
                story_images: [],
                tags: [],
                social_media_images: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IBrandViewV2Response.ILeanBrand || (IBrandViewV2Response.ILeanBrand = {}));
    IBrandViewV2Response.build = function(partial) {
        return _object_spread({
            banners: [],
            related_search_terms: [],
            brand_videos: [],
            active_season_years: [],
            info_texts: [],
            faire_funded_promo: [],
            highlighted_apparel_seasons_for_promotional_event: [],
            promo_display_texts: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IBrandViewV2Response || (IBrandViewV2Response = {}));
export var IBrandViewV2Response;
